import React, { useEffect, useContext } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Form from '../Form/Form';
import TextTabContent from './TextTabContent/TextTabContent';
import SchedulePublish from './TextTabContent/SchedulePublish';
import IngredientsTabContent from './IngredientsTabContent/IngredientsTabContent';
import PlatingTabContent from './PlatingTabContent';
import OverviewTabContent from './OverviewTabContent/OverviewTabContent';
import VersionsTabContent from './VersionsTabContent/VersionsTabContent';
import AvailabilityTabContent from './AvailabilityTabContent/AvailabilityTabContent';
import MarketOverviewTab from './OverviewTabContent/MarketOverViewTab';
import FormContext from '../Form/FormContext';
import { getIsDataDirty } from '../../features/app/selectors';
import PpsiToolbarContent from './PpsiToolbarContent';
import { States } from '../../features/PpsiContainer/constants';
import { dataLabelsPropTypes } from '../Form/propTypes';
import { Mode, modePropType } from './constants';
import { getIsGlobalUser } from 'features/loginSystem/selectors';
import HistoryTabContent from './HistoryTabContent/HistoryTabContent';
import GlobalRefrenceTabContent from './GlobalRefrenceTabContent/GlobalRefrenceTabContent';
import { fetchGlobalPpis } from 'features/PpiContainer/actions';
import {
  getIsFetchingGlobal,
  getPpisAll
} from 'features/PpiContainer/selectors';
import { toJS } from 'utils/immutableUtils';
import AvailabilityTabContentByStatus from './AvailabilityTabContent/AvailabilityTabContentByStatus';

function isDraftOrCreateForm(formData) {
  return (
    formData.status === States.DRAFT ||
    !formData.status ||
    formData.status === States.GLOBALREJECTED
  );
}

const PpsiForm = ({
  data,
  defaultData,
  dataLabels,
  showProgress = false,
  mode,
  useMarketLanguage,
  onGlobalApprovePpsi = () => {},
  onGlobalRejectPpsi = () => {},
  onSubmitForReview = () => {},
  onSave = () => {},
  onApprove = () => {},
  onPublishEmptyPpsi = () => {},
  onPublish = () => {},
  onUnpublish = () => {},
  onCreateDraft = () => {},
  oniFoodUpdatePpsi = () => {},
  onGlobalUpdatePpsi = () => {},
  setOpenConfirm = () => {},
  completePpsiData,
  globalData,
  isGlobalReferenceHidden = false
}) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const isGlobalUser = useSelector(getIsGlobalUser);
  // const getConfigData = useSelector(getIsDataDirty);
  const isLocalUser = !isGlobalUser;
  const isFetchingGlobal = useSelector(getIsFetchingGlobal);
  // const ppis = useSelector(getPpisAll);
  // const globalPpi = toJS(ppis, []);

  function isDraftOrCreateForm(formData) {
    return (
      formData.status === States.DRAFT ||
      !formData.status ||
      (formData.status === States.GLOBALREJECTED && isLocalUser)
    );
  }
  function isAvailabilityVisible(formData) {
    return (
      (formData.status === States.PUBLISHED && isLocalUser) ||
      (formData.status === States.GLOBALAPPROVED && isLocalUser) ||
      (formData.status === States.UNPUBLISHED && isLocalUser) ||
      (formData.status === States.SCHEDULED && isLocalUser) ||
      formData.status === States.GLOBALREVIEW
    );
  }

  function isDisplayScheduleForm(formData) {
    return formData.status === States.GLOBALAPPROVED && isLocalUser;
  }

  function isDraftGlobalReview(formData) {
    return formData.status === States.GLOBALREVIEW && isGlobalUser;
  }

  function isGlobalBasedLocal(formData) {
    return formData.parentPpsiId !== null && mode !== Mode.CREATE;
  }

  function isNotDraftGlobalReview(formData) {
    // console.log(data,"data will come in parent")
    const diplay = formData.status === States.GLOBALREVIEW && isGlobalUser;
    return !diplay;
  }
  function isAdminGlobalRefrence(formData) {
    return formData.status === States.GLOBALREVIEW && isGlobalUser;
  }
  function isGlobalRefrence(formData) {
    const diplay = isGlobalReferenceHidden
      ? false
      : globalData && globalData.market === 'IFS' && !isGlobalUser;
    return diplay;
  }
  function mergeDataLabels() {
    return {
      titleContext: () => formatMessage({ id: 'ppsi.titleContent' }),
      ...dataLabels
    };
  }

  function isNotInCreateMode(formData) {
    const diplay = formData.status === States.GLOBALREVIEW && isGlobalUser;
    return mode !== Mode.CREATE && !diplay;
  }
  console.log(mode, 'what mode');
  return (
    <Form
      data={data}
      defaultData={defaultData}
      completePpsiData={completePpsiData}
      useMarketLanguage={useMarketLanguage}
      tabs={[
        {
          name: 'text',
          label: 'ppsi.textTab',
          // TabContent: TextTabContent,
          TabContent: props => (
            <TextTabContent {...props} globalData={globalData} mode={mode} />
          ),
          visible: isDraftOrCreateForm
        },
        {
          name: 'schedulepublish',
          label: 'ppsi.schedulePublishTab',
          TabContent: SchedulePublish,
          visible: isDisplayScheduleForm
        },
        {
          name: 'ingredients',
          label: 'ppsi.ingredientsTab',
          TabContent: IngredientsTabContent,
          visible: isDraftOrCreateForm
        },
        {
          name: 'plating',
          label: 'ppsi.platingTab',
          TabContent: PlatingTabContent,
          visible: isDraftOrCreateForm
        },
        {
          name: 'availability',
          label: 'ppsi.availabilityTab',
          TabContent: AvailabilityTabContent,
          visible: isDraftOrCreateForm
        },
        {
          name: 'overview',
          label: 'ppsi.overviewTab',
          TabContent: OverviewTabContent,
          tabContentPadding: 'none',
          visible: isNotDraftGlobalReview
        },
        {
          name: 'globalrefrence',
          label: 'ppsi.globalRefrenceTab',
          TabContent: props => (
            <GlobalRefrenceTabContent {...props} globalData={globalData} />
          ),
          tabContentPadding: 'none',
          visible: isGlobalRefrence
        },
        {
          name: 'marketoverview',
          label: 'ppsi.overviewTab',
          TabContent: MarketOverviewTab,
          tabContentPadding: 'none',
          visible: isDraftGlobalReview
        },
        {
          name: 'adminglobalrefrence',
          label: 'ppsi.globalRefrenceTab',
          TabContent: props => (
            <GlobalRefrenceTabContent {...props} globalData={globalData} />
          ),
          tabContentPadding: 'none',
          visible: isAdminGlobalRefrence
        },
        {
          name: 'versions',
          label: 'ppsi.versionsTab',
          TabContent: VersionsTabContent,
          visible: isNotInCreateMode
        },
        {
          name: 'history',
          label: 'ppsi.historyTab',
          TabContent: HistoryTabContent,
          visible: isGlobalBasedLocal
        },
        {
          name: 'availability',
          label: 'ppsi.availabilityTab',
          // TabContent: AvailabilityTabContent,
          TabContent: props => (
            <AvailabilityTabContentByStatus {...props} isAvailablity />
          ),
          visible: isAvailabilityVisible
        }
      ]}
      dataLabels={mergeDataLabels()}
      showProgress={showProgress}
      ToolbarContent={({ data: formData }) => (
        <PpsiToolbarContent
          data={formData}
          onSave={onSave}
          onApprove={onApprove}
          onPublishEmptyPpsi={onPublishEmptyPpsi}
          onPublish={onPublish}
          onUnpublish={onUnpublish}
          onCreateDraft={onCreateDraft}
          mode={mode}
          oniFoodUpdatePpsi={oniFoodUpdatePpsi}
          onGlobalUpdatePpsi={onGlobalUpdatePpsi}
          onGlobalApprovePpsi={onGlobalApprovePpsi}
          onGlobalRejectPpsi={onGlobalRejectPpsi}
          onSubmitForReview={onSubmitForReview}
          completePpsiData={completePpsiData}
          setOpenConfirm={setOpenConfirm}
        />
      )}
    />
  );
};

PpsiForm.propTypes = {
  data: PropTypes.object,
  defaultData: PropTypes.object,
  dataLabels: PropTypes.shape(dataLabelsPropTypes),
  showProgress: PropTypes.bool,
  mode: modePropType.isRequired,
  onSave: PropTypes.func,
  onApprove: PropTypes.func,
  onPublish: PropTypes.func,
  onUnpublish: PropTypes.func,
  onCreateDraft: PropTypes.func,
  oniFoodUpdatePpsi: PropTypes.func,
  onGlobalUpdatePpsi: PropTypes.func
};

export default PpsiForm;
